import { render, staticRenderFns } from "./SingleTableBlue.vue?vue&type=template&id=05f24c10"
import script from "./SingleTableBlue.vue?vue&type=script&lang=js"
export * from "./SingleTableBlue.vue?vue&type=script&lang=js"
import style0 from "./SingleTableBlue.vue?vue&type=style&index=0&id=05f24c10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports